export const FLING_VELOCITY_THRESHOLD = 0.5;
export const FLING_VELOCITY_WINDOW_MS = 100;
